import { render, staticRenderFns } from "./ServiceUnavailableContent.vue?vue&type=template&id=80897790&scoped=true"
import script from "./ServiceUnavailableContent.vue?vue&type=script&lang=js"
export * from "./ServiceUnavailableContent.vue?vue&type=script&lang=js"
import style0 from "./ServiceUnavailableContent.vue?vue&type=style&index=0&id=80897790&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80897790",
  null
  
)

export default component.exports